import { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export const MissingPlayer = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      id="Vector"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3C9 4.65685 7.65685 6 6 6C4.34315 6 3 4.65685 3 3C3 1.34315 4.34315 0 6 0C7.65685 0 9 1.34315 9 3ZM0 11C0 9.34315 1.34315 8 3 8H7.53942C6.59095 9.17804 6.66359 10.9062 7.75735 12C7.20243 12.5549 6.91034 13.2732 6.88111 14H6.76389H0V11ZM14.8284 9.17157C14.4901 8.83326 13.9697 8.78803 13.5827 9.03586C13.523 9.07411 13.4664 9.11934 13.4142 9.17157L12 10.5858L10.5858 9.17157C10.1953 8.78104 9.5621 8.78104 9.17157 9.17157C8.78105 9.56209 8.78105 10.1953 9.17157 10.5858L10.5858 12L9.87868 12.7071L9.17157 13.4142C8.78105 13.8047 8.78105 14.4379 9.17157 14.8284C9.5621 15.2189 10.1953 15.2189 10.5858 14.8284L12 13.4142L13.4142 14.8284C13.8047 15.2189 14.4379 15.2189 14.8284 14.8284C15.219 14.4379 15.219 13.8047 14.8284 13.4142L13.4142 12L14.8284 10.5858C15.219 10.1953 15.219 9.56209 14.8284 9.17157Z"
      fill="currentColor"
    />
  </svg>
);
